import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Form } from 'antd';
import styled from 'styled-components';

export const StyledFormItem = styled(Form.Item)`
  &&& {
    margin: 6px 0;
    width: 100%;
  }
  &&& .ant-form-item-label {
    line-height: 20px;
    padding: 0 0 3px;
  }
`;

export const FormItemComponent = observer(props => {
  const { name, label } = props;

  return (
    <StyledFormItem {...props} label={label === undefined ? name : label}>
      {props.children}
    </StyledFormItem>
  );
});

FormItemComponent.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};
